module.exports = __webpack_public_path__ + "hinted-OpenSans-ExtraboldItalic.5dccd31d1d402d237335.ttf";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/custom-styles/fonts/hinted-OpenSans-ExtraboldItalic.ttf
// module id = ../../../../../src/assets/custom-styles/fonts/hinted-OpenSans-ExtraboldItalic.ttf
// module chunks = 1